import Service from "../../service/index";

const Auth = {
    namespaced: true,
    state: {
        test : "",
        user: [],
        user_login: null,
        form: {
            first_name: "",
            last_name : "",
            username : "",
            phone_number: "",
            user_type_id: "",
            area_id: "",
            district_id: "",
            province_id: "",
            avatar : null,

            area : null,
            district : null,
            province : null,

        },
        login_form:{
          user_type_id:"",
          area_id:"",
          province_id:"",
          district_id:"",
          password: "",
          hospital:"",

        },
        accessToken: null,
        registerToken : null,
    },
    mutations: {
        SET_USER: (state, user) => {
            state.user = user;
        },
        SET_USER_LOGIN: (state, user) => {
            state.user_login = user;
        },
        SET_TOKEN_REGISTER : (state, token) => {
            state.registerToken = token;
        },
        SET_TOKEN: (state, data) => {
          if (data.success.token) {
            state.accessToken = data.success.token;
          }else{
            state.accessToken = null;
          }
        },
        CLEAR_FORM_DATA: state => {
            state.form = {
                first_name: "",
                last_name : "",
                username : "",
                phone_number: "",
                user_type_id: "",
                area_id: "",
                district_id: "",
                province_id: "",
                avatar : null,

                area : null,
                district : null,
                province : null,
            };
        },
    },
    actions: {
        login({ commit }, data) {
            return Service.Auth.login(data).then(response => {
                commit("SET_USER_LOGIN", response);
                commit("SET_TOKEN", response);
            });
        },
        register({ commit }, data) {
            return Service.Auth.register(data).then(response => {
                commit("SET_TOKEN_REGISTER", response.success.token);
                commit("SET_USER", response);
                return data;
            });
        },
        logout({ commit }) {
            return Service.Auth.logout()
                .catch(() => {})
                .finally(() => {
                    commit("SET_USER_LOGIN", null);
                });
        },
        clearFormData({ commit }) {
            commit("CLEAR_FORM_DATA");
        },
        setUser({commit}) {
            return Service.Auth.getUserAll().then(res => {
                commit("SET_USER", res);
            });
        },
        getToken({ commit }, data) {
            return Service.Auth.getToken(data).then(data => {
                commit("SET_TOKEN", data.success.token);
            }).catch(err => Promise.reject(err));
        },
        getTest({commit}, data){
            commit("TEST",data);
        },
      contact({ commit }, data) {
          console.log('data', data)
        return Service.Auth.contact(data).then(response =>{
        });
      },
    }
};

export default Auth;
